// Add future product lessons here without changing the page layout.
const lessons = Object.freeze([
  Object.freeze({
    id: 'pg-solution',
    productId: 'pg-solution',
    descriptionKey: 'learning.pgSolutionDescription',
    duration: '4:25',
    video: '/ELearning/pg-solution/tutorial.mp4',
    poster: '/ELearning/pg-solution/poster.jpg',
  }),
]);

export default lessons;
